import { render, staticRenderFns } from "./Q_A.vue?vue&type=template&id=6fb8939a&scoped=true&"
import script from "./Q_A.vue?vue&type=script&lang=js&"
export * from "./Q_A.vue?vue&type=script&lang=js&"
import style0 from "./Q_A.vue?vue&type=style&index=0&id=6fb8939a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8939a",
  null
  
)

export default component.exports